import { HeadLine } from '../../layouts/headers/HeadLine';
import CSS from 'csstype';
import GeneralButtonComponent from '../../components/button/GeneralButtonComponent';
import { RestaurantCardList } from './components/RestaurantCardList';
import './Style.css';
import { MainService } from '../../controllers/MainService';
import { useEffect, useRef, useState } from 'react';
import { NoAuthAlertComponent } from '../../components/card/NoAuthAlertComponent';
import { useSelector } from 'react-redux';

export const RestaurantMainPage = () => {

    const user = useSelector((state: any) => state.auth);
    const container = useRef(null);
    const [scrollpos, setScrollpos] = useState(258);

    useEffect(() => {

        const updateScrollPosition = (e) => {
            if (e.target.scrollTop === 0) {
                setScrollpos(258);
            }
            if (e.target.scrollTop > 0) {
                setScrollpos(77);
            }
        }

        if (container && container.current) {

            let listener = container.current;

            listener.addEventListener("scroll", updateScrollPosition, {
                capture: false,
                passive: false
            });

            return () => {
                listener.removeEventListener("scroll", updateScrollPosition, {
                    capture: false,
                    passive: false
                });
            };
        }
    }, [container]);



    const restaurants = MainService.getRestaurants();

    const bgimage: CSS.Properties = { background: "linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 100%), url('/assets/img/post3.png') no-repeat center center / cover" };

    const [filter, setFilter] = useState(0);

    const handleFilter = (sel: number) => {
        setFilter(sel);
    }

    return (<>
        <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
            <HeadLine title='Restaurantes & Bares' backurl='/' />
        </div>

        <div className="w-full relative content-hi-sm ">
            <div className="bg_room_page flex justify-center items-center" style={bgimage}>
                <img src="/assets/img/icons/restaurant-icon.svg" alt="Icono room" />
            </div>
        </div>
        <div className="fixed z-1 w-full border shadow detail-process-room-container pb-4 bg_page_top" ref={container} style={{ height: `calc(100% - ${scrollpos}px)` }}>

            <div className="m-auto max-w-lg">
                {
                    !user && (<div className='mt-4' style={{ marginRight: '-14px' }}>
                        <NoAuthAlertComponent />
                    </div>)
                }

                <div className='text-center mt-4' style={titleSentenceStyles}>
                    ¡Conoce la variedad de restaurantes y bares que tenemos para tí!
                </div>

                <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-2 px-6 w-full mt-4' click={() => { handleFilter(0) }}
                    bgcolor={filter === 0 ? '#67BAAF' : '#B3D0CC'} textcolor={filter === 0 ? '#ffffff' : 'rgb(45, 87, 82)'} > Todos los Restaurantes & Bares </GeneralButtonComponent>

                <div className='flex'>
                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-2 px-6 w-full mt-4 mr-4' click={() => { handleFilter(1) }}
                        bgcolor={filter === 1 ? '#67BAAF' : '#B3D0CC'} textcolor={filter === 1 ? '#ffffff' : 'rgb(45, 87, 82)'} > Sin reservación necesaria </GeneralButtonComponent>
                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-2 px-6 w-full mt-4' click={() => { handleFilter(2) }}
                        bgcolor={filter === 2 ? '#67BAAF' : '#B3D0CC'} textcolor={filter === 2 ? '#ffffff' : 'rgb(45, 87, 82)'} > Reservación necesaria </GeneralButtonComponent>
                </div>

                <br />
                <hr />

                <div className='text-center mt-4' style={texto2}>Sin reservación necesaria</div>

                <RestaurantCardList items={restaurants} filter={filter} userdata={user} />
            </div>

        </div>
    </>);
};

const titleSentenceStyles: CSS.Properties = {
    fontSize: '16px',
    fontWeight: '600',
    color: '#012349',
    lineHeight: '18px'
}

const texto2: CSS.Properties = {
    fontSize: '18px',
    fontWeight: '600',
    color: '#67BAAF',
    lineHeight: '18px'
}
